import { Component, h, Prop, State, Watch } from '@stencil/core';
import {
  getQueryParameter,
  replaceUrlParam,
} from 'libs/env-components/src/lib/helper/global.helper';
import Device from 'libs/env-components/src/lib/services/device/device.service';

@Component({
  tag: 'envc-accordion-img',
  styleUrl: 'envc-accordion-img.scss',
})

export class EnvcAccordionImg {
  /** Die Image Url */
  @Prop({ reflect: true }) url: string;
  @Watch('url')
  urlHandler() {
    this.resizeImage();
  }
  /** Der alternative Text für das Image falls es nicht angezeigt werden kann */
  @Prop() alt: string;

  @State() contentEl: HTMLElement;
  @State() resizedUrl: string;
  @State() isLoaded: boolean;

  /** Behandelt Breakpoint-Änderungen */
  private handleBreakpoints(): void {
    Device.breakpointEvent.subscribe(() => {
      this.resizeImage();
    });
  }

  /** Errechnet die zur Zeit benötigte Größe des Images und ersetzt dementsprechend die h und w Parameter für den ImageResizer im Url */
  private resizeImage(): void {
    const rect = this.contentEl ? this.contentEl.getBoundingClientRect() : null;
    if (this.url && rect) {
      const currWidth = parseInt(getQueryParameter(this.url, 'w'));
      const currHeight = parseInt(getQueryParameter(this.url, 'h'));
      const imageRatio =
        currWidth && currHeight ? currHeight / currWidth : null;
      const newWidth = currWidth && rect.width ? rect.width : null;
      const newHeight =
        imageRatio && newWidth
          ? newWidth * imageRatio
          : currHeight
          ? rect.height
          : null;
      let tmpUrl = this.url;
      if (newWidth || newHeight) {
        tmpUrl = newWidth
          ? replaceUrlParam(tmpUrl, 'w', newWidth.toFixed())
          : tmpUrl;
        tmpUrl = newHeight
          ? replaceUrlParam(tmpUrl, 'h', newHeight.toFixed())
          : tmpUrl;
      }
      this.resizedUrl = tmpUrl;
    }
  }

  private init(): void {
    this.handleBreakpoints();
  }

  /** Wird aufgerufen, wenn die Komponente vollständig geladen ist. */
  componentDidLoad(): void {
    this.init();
  }

  componentDidUpdate(): void {
    if (!this.isLoaded) {
      this.isLoaded = true;
      this.resizeImage();
    }
  }

  render() {
    if (this.url) {
      return (
        <div
          class="accordion-mit-bild__image"
          ref={(contentEl) => (this.contentEl = contentEl)}
        >
          <figure class="image image-semantic">
            <picture>
              <img
                loading="lazy"
                alt={this.alt}
                srcset={this.resizedUrl}
                src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
              ></img>
            </picture>
          </figure>
        </div>
      );
    }
  }
}
